import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const microServiceUrl = process.env.REACT_APP_SERVICE_URL;

export const saveLeadResponse = (leadRespData) =>
  axios.post(`${microServiceUrl}/lead-response`, leadRespData);

export const saveUpcomingLeadInfo = (payload) =>
  axios.post(`${baseUrl}/upcoming-lead-info`, payload);

export const getUpcomingLeadById = ({ id, includeDeleted = false }) =>
  axios.get(`${baseUrl}/upcoming-lead-info/${id}`, {
    params: { includeDeleted }
  });

export const softDeleteUpcomingLeadInfo = (id) =>
  axios.delete(`${baseUrl}/upcoming-lead-info/${id}`);

export const fetchFunnelBySite = (paramsObj) =>
  axios.get(`${microServiceUrl}/funnel/site`, {
    params: paramsObj
  });

export const fetchSenderId = () =>
  axios.get(`${baseUrl}/funnel-insight/senderId`);

// Split test on the order form (Cockpit, Asana 1219217770567617): which
// variant this visitor sees. Short timeout — the form must never wait for it.
export const fetchSplitTestAssignment = (params) =>
  axios.get(`${baseUrl}/split-test/assignment`, { params, timeout: 1500 });

export const recordSplitTestExposure = (payload) =>
  axios.post(`${baseUrl}/split-test/exposure`, payload);

// Order-form context (split-test elements v2): resolved colours, real
// social-proof count and the company's Google rating. Never awaited by the
// form — without it the form renders as before.
export const fetchFormContext = (funnelId) =>
  axios.get(`${baseUrl}/split-test/form-context`, {
    params: { funnelId },
    timeout: 1500
  });

export const checkPostalCode = (funnelId, postalCode) =>
  axios.get(`${microServiceUrl}/funnel/site/check-postalcode`, {
    params: { funnelId, postalCode }
  });

export const sendAdDetails = async (payload) => {
  await axios.post(`${baseUrl}/funnel/ad-details`, payload);
};

export const recordBlockedPostalCode = (leadPayload) =>
  axios.post(`${baseUrl}/lead-response/record-blocked-postalcode`, leadPayload);

export const saveRecordAction = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/recordAction`, payload);

export const recordWebsiteVisit = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/website/record`, payload);

export const deleteQuestionVisit = (payload) =>
  axios.post(`${baseUrl}/funnel-insight/remove-insight`, payload);

export const saveLeadAddress = (id, { description, placeId, funnel }) =>
  axios.patch(`${baseUrl}/lead-response/save-address/${id}`, {
    description,
    placeId,
    funnel
  });

export const fetchAddressAutocompleteOptions = (queryText) =>
  axios.get(`${baseUrl}/address/autocomplete`, { params: { queryText } });

export const fetchAMPrivacyPolicy = () =>
  axios.get(`${baseUrl}/workspace/get-policy`);

export const fetchWorkspaceForGlobalThankyou = () =>
  axios.get(`${baseUrl}/workspace/get-global-reclaim-config`);

export const fetchWorkspaceForDigitalThankyou = () =>
  axios.get(`${baseUrl}/workspace/get-digital-thankyou-page`);
